export const RUNTIME_ACTIVE_POLL_MS = 1_500;
export const RUNTIME_IDLE_POLL_STEPS_MS = [10_000, 20_000, 30_000] as const;
export const RUNTIME_ERROR_POLL_MS = 30_000;

export function runtimePollDelay(activeCount: number, idlePollCount: number) {
  if (activeCount > 0) return RUNTIME_ACTIVE_POLL_MS;
  const index = Math.min(Math.max(0, idlePollCount), RUNTIME_IDLE_POLL_STEPS_MS.length - 1);
  return RUNTIME_IDLE_POLL_STEPS_MS[index];
}
